module.exports = __webpack_public_path__ + "img/boat.d220da4d.svg";